import endpoints from "../../functions/databaseEndpoints";
export async function updateUserInDB(userData, userToken) {
   const mainEndpoint = `${endpoints.PRIVATE_ENDPOINT}updateClient`;
   try {
      const rawResponse = await fetch(mainEndpoint, {
         method: "POST",
         headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: userToken,
         },
         body: JSON.stringify(userData),
      });
      const content = await rawResponse.json();
      return content;
   } catch (e) {
      alert(e.message);
   }
   return { status: false };
}
